import { hot } from 'react-hot-loader'
import React from 'react'
import Contact from '../components/Contact/Contact'

function App() {
  return (
    <>
      <Contact />
    </>
  )
}

export default hot(module)(App)
